<!--<app-client-portal-header></app-client-portal-header>-->

<div *ngIf="{ enableMagicLinkExperience: enableMagicLinkExperience$ | async } as cfg" class="client-key-container">
  <!-- span spacer -->
  <span></span>
  <div class="login-container">
    <div class="login">
      <aiwyn-logo height="60" [extraClasses]="'mb--200 login__logo'"></aiwyn-logo>

      <div class="block login__cont">
        <div *ngIf="!cfg.enableMagicLinkExperience" class="grid-row grid-row--jcc">
          <div class="grid-col grid-col--auto">
            <button type="button" class="mb--125 button button--simple" (click)="goBack()">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              <span>Go back</span></button>
          </div>
        </div>
        <div>

          <h2 *ngIf="isAnonymousUser; else contactHeaderTemplate" class="mb--075">
            {{ cfg.enableMagicLinkExperience ? 'Make a payment as a guest' : 'Pay Invoices without an Account' }}
          </h2>

          <ng-template #contactHeaderTemplate>
            <h2 *ngIf="!isAnonymousUser" class="mb--075">Add an Account</h2>
          </ng-template>

          <div *ngIf="!cfg.enableMagicLinkExperience">
            <mat-icon class="key--icon">vpn_key</mat-icon>
            <span style="padding-left: 5px">{{ clientKeyInstructionText }}</span>
          </div>

          <img
            *ngIf="!cfg.enableMagicLinkExperience"
            [src]="assetsUriService.customerAssetUrl + 'client-key-image.svg'"
            onerror="style.display='none'"
            class="mb--125 client-key__image mt--050"
          >

          <form data-private name="clientKeyForm" (ngSubmit)="submit()" [formGroup]="clientKeyForm" class="mt--150">
            <div
              class="{{ cfg.enableMagicLinkExperience ? 'mt-6 body-400 color-gray-300': 'mt--50' }} ta--left"
            >
              {{ clientKeyLabel }}
            </div>

            <input
              #clientKey
              formControlName="clientKey"
              type="text"
              name="clientKey"
              class="form-input mt--025"
              data-cy="client-key"
            />

            <div *ngIf="configService.invoiceNoClientKeyGuestLogin && !configService.relaxedModeEnabled">
              <div
                class="{{ cfg.enableMagicLinkExperience ? 'mt-6 body-400 color-gray-300': 'mt--50' }} ta--left"

              >
                Invoice Number
              </div>

              <input
                #invoiceNumber
                formControlName="invoiceNumber"
                name="invoiceNumber"
                type="text"
                class="form-input mt--025"
              />

              <div *ngIf="!cfg.enableMagicLinkExperience" class="tc--xlight ta--left mt--025">
                Enter an invoice number from any invoice you’ve ever received for this client. If you have never received an invoice for this client, leave this field blank.
              </div>
            </div>

            <div *ngIf="configService.relaxedModeEnabled">
              <div class="mt--050 ta--left">Client Name</div>

              <input
                #clientName
                formControlName="clientName"
                class="form-input mt--025"
                name="clientName"
                type="text"
              />

              <div class="tc--xlight ta--left mt--025">Enter in the name of the organization you are paying on behalf of.</div>
            </div>

            <div *ngIf="!cfg.enableMagicLinkExperience; else newActionBlock" class="mt--100 grid-row grid-row--jcc">
              <div
                class="grid-col grid-col--auto"
                [tooltip]="'All fields must be provided to submit the form'"
                [tooltipEnabled]="!clientKeyForm.valid"
              >
                <button
                  type="submit"
                  andButton
                  size="large"
                  color="default"
                  [disabled]="!clientKeyForm.valid"
                  [isLoading]="isSubmissionProcessing$ | async"
                >
                  Submit
                </button>
              </div>
            </div>

            <ng-template #newActionBlock>
              <button
                andButton
                size="large"
                type="submit"
                color="primary"
                class="w-100 mt-6"
                [disabled]="!clientKeyForm.valid"
                [isLoading]="isSubmissionProcessing$ | async"
              >
                Continue
              </button>

              <div class="mt-8 mb-8 w-100 login__hr"><span>OR</span></div>

              <button
                andButton
                color="secondary"
                type="button"
                size="large"
                class="w-100"
                (click)="goBack()"
              >
                {{ isAnonymousUser ? 'Return to sign - in screen' : 'Go back' }}
              </button>
            </ng-template>
          </form>
        </div>
      </div>

      <div *ngIf="isAnonymousUser && !cfg.enableMagicLinkExperience" class="mt--100 p">
        Not signed up?
        <span class="text-link" (click)="createAccount()">Create an account</span>
      </div>
    </div>

    <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
  </div>

  <div></div>
</div>
